import React from 'react';

import {AlertBanner} from '@udemy/react-messaging-components';

export const NoPlanAlertBanner = () => (
    <AlertBanner
        showCta={false}
        title={gettext(
            "We're working to make Personal Plan available for more learners. Stay tuned.",
        )}
    />
);
